import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {useContext} from 'react';

import {MainFilterContext} from '../../../provider/main-filter/main-filter';
import {MainFilterContextType} from '../../../provider/main-filter/main-filter-type';
import {ReviewsAndAnswersFilterStateType} from '../filter/reviews-and-answers-statistics-filter-type';

import {fetchUsedAutoRepliesCount} from './used-auto-replies-count-api';
import {UsedAutoRepliesCountType} from './used-auto-replies-count-type';

export function useUsedAutoRepliesCount(
    filter: ReviewsAndAnswersFilterStateType
): UseQueryResult<UsedAutoRepliesCountType> {
    const {mainFilterKey} = useContext<MainFilterContextType>(MainFilterContext);

    return useQuery({
        queryKey: ['usedAutoRepliesCount', filter, mainFilterKey],
        queryFn: async () => {
            return fetchUsedAutoRepliesCount(filter, mainFilterKey);
        },
    });
}
